// @packages
import { makeStyles } from '@rneui/themed';

export default makeStyles(() => ({
  buttonContainer: {
    marginTop: 30,
    width: '100%'
  },
  button: {
    borderRadius: 20,
    height: 64
  },
  titleStyle: {
    fontSize: 24,
    lineHeight: 64
  }
}));
